import React, { useState } from 'react';
import { ECardTitle, ECardSubTitle, ECardWrapper, StyledCell } from '@components/GalleryComponents/GalleryGrid/GalleryGrid.styles';
import { GalleryECard } from '@components/GalleryComponents/GalleryECard/GalleryECard';
import { DEFAULT_VENDOR } from '@components/GalleryComponents/GalleryComponents.constants';
import { capitalize, snakeToCamelTrimed } from '@utils/strings.util';

interface GalleryECardCellProps
  extends Readonly<{
    index: number;
    card: GalleryECard;
    marginTop?: number;
    isSlider?: boolean;
    showInfo?: boolean;
    onCardClick: (card: GalleryECard) => void;
  }> {}

export const GalleryECardCell: React.FC<GalleryECardCellProps> = ({
  index,
  card,
  onCardClick,
  marginTop = 11,
  isSlider = false,
  showInfo = true,
}) => {
  const [isHovered, setHovered] = useState(false);
  return (
    <StyledCell
      id={`grid${snakeToCamelTrimed(card.variantName ? card.variantName : card.theme?.name)}${capitalize(card.variationType)}`}
      marginTop={marginTop}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onCardClick(card)}
      skipRedirectWithTelemetry
    >
      <ECardWrapper $isHovered={isHovered}>
        <GalleryECard index={index} isSlider={isSlider} data={card} isHovered={isHovered} />
      </ECardWrapper>
      {showInfo && (
        <>
          <ECardTitle className="ecard_title" tagName={'p'} variant={'featureCopy17'} color={'neutra6'} textAlign={'center'}>
            {capitalize(card.variantName ? card.variantName : card.theme?.name)}
          </ECardTitle>
          <ECardSubTitle tagName={'p'} variant={'featureCopy17'} color={'neutra4'} textAlign={'center'}>
            {card.vendor === DEFAULT_VENDOR ? '' : card.vendor}
          </ECardSubTitle>
        </>
      )}
    </StyledCell>
  );
};
